module.exports = __webpack_public_path__ + "img/carbon-filament.b56c00ec.webp";